/* Core & libraries */
import * as React from "react";
import { useTheme } from "react-jss";
import classnames from "classnames";

/* Helpers, constants, custom methods, internal libraries */
import { useSpinnersContext } from "../../contexts/spinnersContext";

/* Components */
import Spinner from "../spinners/buttonSpinner";

/* Styles */
import styles from "./styles.js"


const UCButton = ({ type, text, children, className, onClick, dataTestId, spinner, disabled, icon, iconClassName, iconEnd, loadingStateStyling, textClassName, spinnerClassName, disabledIconClassName, ariaLabel, tabIndex, onMouseEnter }) => {
  const theme = useTheme();
  const classes = styles({ theme });
  const spinners = useSpinnersContext();

  const handleKeyDown = (event) => {
    if (event.key === ' ' || event.key === 'Spacebar') { // ' ' is for older browsers interpretation event key for space
      event.preventDefault();
      if (onClick && !disabled && !spinners[spinner?.name]) {
        onClick(event);
      }
    }
  };

  return (
    <div 
      className={ `${classes[type]} ${className} ${type === "default" && disabled ? classes.defaultDisabled : disabled ? classes.disabled : ""} ${spinners[spinner?.name] ? classes.disabled : ""} ${loadingStateStyling && spinners[spinner?.name] ? loadingStateStyling : ""}` } 
      aria-label={ariaLabel} 
      tabIndex={tabIndex} 
      onClick={onClick} 
      data-testid={dataTestId}
      onKeyDown={handleKeyDown}
      role="button"
      aria-disabled={disabled || !!spinners[spinner?.name]}
      onMouseEnter={onMouseEnter}
    >
      {
        icon &&
          <span className={classnames({[classes.icon]: !iconClassName}, iconClassName, {[disabledIconClassName]: disabled}, {[classes.txtHidden]: spinners[spinner?.name]})}>{icon}</span>
      }
      {
        spinners[spinner?.name] && (
          <Spinner size={spinner['size']} color={theme.spinners[type]} customClass={spinnerClassName || classes.spinnerButton}/>
        )
      }
      <span className={classnames({[classes.txtHidden]: spinners[spinner?.name]}, textClassName)}>{ text }</span>
      { children }
      {
        iconEnd &&
        <span className={`${iconClassName ? iconClassName : classes.iconEnd}  ${spinners[spinner?.name] && classes.txtHidden}`}>{iconEnd}</span>
      }
    </div>
  )
}

export default UCButton;
